<template>
  <v-container>
    Sales Outstanding


  </v-container>
</template>

<script>

import api from "@/services/api";
import { server } from "../services/constants";

export default {
  mounted() {
    // this.$showLoader();
    setTimeout(() => {
      this.$hideLoader();
    }, 500);
  },

  data() {
    return {
      isShowPassword: false,
      fullPage: true,
    };
  },
  methods: {},
  beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>

<style></style>
